import * as Yup from 'yup'

export const stickyNoteValidationSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
})

export const stickyNoteInitialValues = { name: '', display: { html: '' } }
